import { cn } from "@utils/tw"
import { ComponentProps } from "react"

export function Spinner(props: ComponentProps<"div">) {
  return <span {...props} className={cn("spinner", props.className)}></span>
}

export function AreaSpinner(props: Omit<ComponentProps<"div">, "children">) {
  return (
    <div className={cn("p-6 flex items-center justify-center", props.className)} {...props}>
      <Spinner />
    </div>
  )
}
